import { toast } from "react-toastify";

export const CART_SET_INITIAL = "CART_SET_INITIAL";
export const CART_EMPTY = "CART_EMPTY";
export const CART_RESET = "CART_RESET";
export const CART_ADD_ITEM = "CART_ADD_ITEM";
export const CART_ADD_ITEM_BY_ID = "CART_ADD_ITEM_BY_ID";
export const CART_REMOVE_ITEM = "CART_REMOVE_ITEM";
export const CART_SET_COMMENT = "CART_SET_COMMENT";
export const CART_SET_YOUR_REFERENCE = "CART_SET_YOUR_REFERENCE";
export const CART_SET_DELIVERY_INSTRUCTIONS = "CART_SET_DELIVERY_INSTRUCTIONS";
export const CART_SET_PRODUCT_SEARCH = "CART_SET_PRODUCT_SEARCH";
export const CART_SET_PURCHASE_ORDER_NUMBER = "CART_SET_PURCHASE_ORDER_NUMBER";

export const cartSetInitial = (cart) => ({
  type: CART_SET_INITIAL,
  cart,
});

export const cartEmpty = () => ({
  type: CART_EMPTY,
});

export const cartReset = () => ({
  type: CART_RESET,
});

export const cartAddItem = (brewery, product, quantity) => ({
  type: CART_ADD_ITEM,
  brewery,
  product,
  quantity,
});

export const cartAddItemById = (brewery, items) => ({
  type: CART_ADD_ITEM_BY_ID,
  brewery,
  items,
});

export const cartSetComment = (comment) => ({
  type: CART_SET_COMMENT,
  comment,
});

export const cartSetYourReference = yourReference => ({
  type: CART_SET_YOUR_REFERENCE,
  yourReference,
});

export const cartSetDeliveryInstructions = deliveryInstructions => ({
  type: CART_SET_DELIVERY_INSTRUCTIONS,
  deliveryInstructions,
});

export const cartSetProductSearch = productSearch => ({
  type: CART_SET_PRODUCT_SEARCH,
  productSearch,
});

export const cartSetPurchaseOrderNumber = purchaseOrderNumber => ({
  type: CART_SET_PURCHASE_ORDER_NUMBER,
  purchaseOrderNumber,
});

export const cartRemoveItem = (item) => ({
  type: CART_REMOVE_ITEM,
  item,
});


export const cartInitialState = {
  cart: {},
  cartLoaded: false,
};

export const cartReducer = (previousState, action) => {
  const newState = { ...previousState };
  const { cart, product } = newState;
  switch (action.type) {
    case CART_SET_INITIAL:
      newState.cart = action.cart;
      newState.cartLoaded = true;
      return newState;
    case CART_EMPTY:
      newState.cart.items = [];
      return newState;
    case CART_RESET:
      newState.cartLoaded = false;
      delete newState.product;
      delete newState.order;
      return newState;
    case CART_SET_COMMENT:
      cart.comment = action.comment;
      return newState;
    case CART_SET_YOUR_REFERENCE:
      cart.yourReference = action.yourReference;
      return newState;
    case CART_SET_DELIVERY_INSTRUCTIONS:
      cart.deliveryInstructions = action.deliveryInstructions;
      return newState;
    case CART_SET_PRODUCT_SEARCH:
      cart.productSearch = action.productSearch;
      return newState;
    case CART_SET_PURCHASE_ORDER_NUMBER:
      cart.purchaseOrderNumber = action.purchaseOrderNumber;
      return newState;
    case CART_ADD_ITEM_BY_ID:
      if (typeof product === 'undefined') {
        toast.error("Var god och klicka på produktfliken så produkterna laddas in först.");
        return newState;
      }
      action.items.forEach(i => {
        const breweryProduct = product.items.find(p => p.id === i.productId);
        if (breweryProduct !== undefined) {
          let item = cart.items.find(item => item.product.id === breweryProduct.id);
          const quantity = action.brewery.backorder ? i.quantity : (i.quantity <= breweryProduct.quantity ? i.quantity : breweryProduct.quantity);
          if (item === undefined) {
            item = cart.items.push({ product: breweryProduct, quantity: quantity });
          } else {
            item.quantity = quantity;
          }
        }
      });
      toast.success("Produkterna finns nu i varukorgen.");
      return newState;
    case CART_ADD_ITEM:
      const brewery = action.brewery;
      let quantity = action.quantity;
      if (!brewery.backorder) {
        if (isNaN(action.quantity)) {
          return newState;
        } else {
          quantity = action.quantity <= action.product.quantity ? action.quantity : action.product.quantity;
        }
      }
      const item = cart.items.find(item => item.product.id === action.product.id);
      if (typeof item === 'undefined') {
        cart.items.push({ product: action.product, quantity: quantity });
      } else {
        item.quantity = quantity;
        item.product = action.product;
      }
      cart.items = cart.items.filter(item => item.quantity > 0);
      return newState;
    default:
      return previousState;
  }
}

export default cartReducer;
